// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\signup.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\signup.tsx");
  import.meta.hot.lastModified = "1759761980446.823";
}
// REMIX HMR END

import { SignupFirst } from "~/components/auth";
import { PublicRoute } from "~/components/RouteProtection";
export const meta = () => {
  return [{
    title: "Sign Up | Nomadics"
  }, {
    name: "description",
    content: "Join the global creative community"
  }];
};
export default function Signup() {
  return <PublicRoute>
      <SignupFirst />
    </PublicRoute>;
}
_c = Signup;
var _c;
$RefreshReg$(_c, "Signup");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;